import axios from 'axios';

export default ({ requiresAuth = false, fileUpload = false, errAsObj = false } = {}) => {

    let headers = {
        Authorization: null
    }
    if(fileUpload){
       headers = {
                Authorization:null,
               'Content-Type' : 'multipart/form-data'
       }
    }

    const options = {
        headers:headers
    };

    //options.baseURL = 'http://127.0.0.1:8000/'
    //? Decide add token or not


  options.baseURL = localStorage.getItem('baseUrl') || 'https://api.perfecthome.com';
  if (window.location.hostname === 'localhost'){
    options.baseURL = 'https://apidev.perfecthome.com';
  } else {
    //console.log('this is not localhost ');
  }

  //console.log('determining base url: localStorage: [' + localStorage.getItem('baseUrl') + '] locationhostname: [' + window.location.hostname + '] USING baseURL:', options.baseURL);

    if (requiresAuth) {
        let token = ''
        try{
            token = JSON.parse(window.localStorage.getItem('authToken'));
        } catch (e) {
            console.log("Failed parsing JSON")
        }
        options.headers.Authorization = `Bearer ${token}`

    }




    const instance = axios.create(options);
    instance.interceptors.response.use(response => {
        return response;
    }, error => {
        if(errAsObj){
            return Promise.reject(error.response.data)
        }
        if(error.response){
            return Promise.reject(error.response.data.message)
        }
        return Promise.reject(error.message);
    });

    return instance;
};
